export const COMMON_LOADING = 'COMMON_LOADING' as const
export const COMMON_ERROR = 'COMMON_ERROR' as const
export const COMMON_SUCCESS = 'COMMON_SUCCESS' as const
export const COMMON_RESET_MESSAGE = 'COMMON_RESET_MESSAGE' as const
export const COMMON_RESET = 'COMMON_RESET' as const